import React from 'react'
const OrderThankYou = () => {
    return (
        <div className={`thank-order`}>
            <section className="login-main-wrapper">
                <div className="main-container">
                    <div className="login-process">
                        <div className="login-main-container">
                            <div className="thankyou-wrapper">
                                <h1>
                                    <img
                                        src="/assets/images/thank-you.png"
                                        alt="thanks"
                                    />
                                </h1>
                                <p>Order placed successfully! Thank you for choosing our services. If you have any questions or concerns, feel free to reach out to our customer support team.</p>
                                <a href="/dashboard">Back to Dashboard</a>
                                <div className="clr" />
                            </div>
                            <div className="clr" />
                        </div>
                    </div>
                    <div className="clr" />
                </div>
            </section>
        </div>
    )
}

export default OrderThankYou